import React from 'react';
import { AlertCircle } from 'lucide-react';
import toast from 'react-hot-toast';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ApiErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    toast.error('Wystąpił błąd podczas komunikacji z serwerem');
    console.error('API Error:', error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
          <div className="max-w-2xl w-full bg-white rounded-xl shadow-lg p-8 border border-red-100">
            <div className="flex items-center gap-3 text-red-600 mb-4">
              <AlertCircle className="w-8 h-8" />
              <h2 className="text-xl font-bold">Ups! Coś poszło nie tak</h2>
            </div>
            <p className="text-gray-600 mb-4">Wystąpił nieoczekiwany błąd aplikacji.</p>
            
            {this.state.error && (
              <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
                <p className="text-red-400 font-mono text-sm mb-2 font-bold">
                  {this.state.error.toString()}
                </p>
                <pre className="text-gray-400 font-mono text-xs leading-relaxed">
                  {this.state.error.stack}
                </pre>
              </div>
            )}
            
            <button 
              onClick={() => window.location.reload()}
              className="mt-6 px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
            >
              Odśwież stronę
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
